export default __webpack_public_path__ + "static/media/DBY.606ac092.png";